/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/service/config.service';
import moment from 'moment';
import { TokenService } from 'src/app/shared/services/customer-api/token.service';
import { INTERNAL_COCKPIT_SETTINGS } from 'src/app/shared/utils/cockpit-constants';
import { RoutingService } from 'src/app/service/routing.service';

export abstract class ApiBaseService {
  constructor(
    protected http: HttpClient,
    protected config: ConfigService,
    protected routing: RoutingService,
    protected tokenService: TokenService,
  ) {}

  protected abstract getRequestUrl(endpoint: string, version?: string): string;

  protected getOption(params: any) {
    const startDay = this.config.appConfig.setup.startDate;

    if (params && params['from'] && params['from'] < startDay) {
      params['from'] = startDay;
    }

    if (params && params['to'] && params['to'] < startDay) {
      params['to'] = moment(startDay).add(1, 'days').format('YYYY-MM-DD');
    }

    if (params && params['from'] && params['to'] && !params['izoom']) {
      const days = moment(params['to']).diff(moment(params['from']), 'days');
      const maxDays = INTERNAL_COCKPIT_SETTINGS.maxTimeframe;
      if (!this.routing.isDev() && !this.routing.isWidget() && days > maxDays) {
        params['from'] = moment(params['to'])
          .subtract(maxDays, 'days')
          .format('YYYY-MM-DD');
      }
    }

    if (params && params['izoom']) {
      delete params['izoom'];
    }

    // Reader/widget URL JWT — push into the single token source so AuthInterceptor
    // picks it up on this request. Reader contexts are single-token-per-session.
    if (params?.jwt) {
      this.tokenService.tokenDataAccess = params.jwt;
      delete params['jwt'];
    }

    if (params && params['to']) {
      params['date_to'] = params['to'];
      delete params['to'];
    }
    if (params && params['from']) {
      params['date_from'] = params['from'];
      delete params['from'];
    }

    const headersObject: Record<string, string> = {
      Accept: 'application/json',
    };
    if (
      params &&
      Object.prototype.hasOwnProperty.call(params, 'headerIncludeNewsIds')
    ) {
      headersObject['Include-News-Ids'] = params['headerIncludeNewsIds'];
      delete params['headerIncludeNewsIds'];
    }
    if (
      params &&
      Object.prototype.hasOwnProperty.call(params, 'headerExcludeNewsIds')
    ) {
      headersObject['Exclude-News-Ids'] = params['headerExcludeNewsIds'];
      delete params['headerExcludeNewsIds'];
    }

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (typeof value === 'string' || value instanceof String) {
          params[key] = value.split(',');
        }
      });
    }

    return {
      params: params,
      headers: new HttpHeaders(headersObject),
    };
  }

  get<T>(endpoint: string, params: any, version?: string): Observable<T> {
    const url = this.getRequestUrl(endpoint, version);
    return this.http.get<T>(url, this.getOption(params));
  }

  post<T>(
    endpoint: string,
    body: any,
    params?: any,
    version?: string,
  ): Observable<T> {
    const url = this.getRequestUrl(endpoint, version);
    return this.http.post<T>(url, body, this.getOption(params));
  }
}
